module.exports = __webpack_public_path__ + "img/guide1.9c7c8b23.png";